// extracted by mini-css-extract-plugin
export var icon = "_5t-1";
export var subtext = "_5t-0";